import {Module} from "vuex";
import {OrdersState} from "@/store/Orders/types";
import {RootState} from "@/store/types";
import Order from "@/api/Order";
import OrderService from "@/service/OrderService";

const OrdersModule: Module<OrdersState, RootState> = {
    namespaced: true,
    state: {
        orders: null
    },
    getters: {
    },
    mutations: {
        assignOrders(state, payload: Order[]){
            console.log(payload);
        }
    },
    actions: {
        async getOrders({commit}){
            const orders = await OrderService.getPaginatedOrders(1);
            commit('assignOrders', orders);
        }
    }
}

export default OrdersModule;

